export default function(state = null, action) {
  switch (action.type) {
    case "GET_STORE_ACTION":
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/getstoredata.js